//import $ from 'jquery';
//Todo: should be a json

import { AccessoryNames } from "./AccessoryNames";
import { AID } from "@/enums/AccessoryIdEnum";
import utils from "@/utils/utils";

const accessoryRepository = {
    //grade one
    'grade_one_item_01': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_01.svg'),
    'grade_one_item_02': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_02.svg'),
    'grade_one_item_03': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_03.svg'),
    'grade_one_item_04': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_04.svg'),
    'grade_one_item_05': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_05.svg'),
    'grade_one_item_06': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_06.svg'),
    'grade_one_item_07': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_07.svg'),
    'grade_one_item_08': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_08.svg'),
    'grade_one_item_09': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_09.svg'),
    'grade_one_item_10': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_10.svg'),
    'grade_one_item_11': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_11.svg'),
    'grade_one_item_12': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_12.svg'),
    'grade_one_item_13': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_13.svg'),
    'grade_one_item_14': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_14.svg'),
    'grade_one_item_15': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_15.svg'),
    'grade_one_item_16': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_16.svg'),
    'grade_one_item_17': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_17.svg'),
    'grade_one_item_18': require('@/assets/image/accessories/Accessories_G1/cloth_g1_item_18.svg'),

    'grade_one_hat_01': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_01.svg'),
    'grade_one_hat_02': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_02.svg'),
    'grade_one_hat_03': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_03.svg'),
    'grade_one_hat_04': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_04.svg'),
    'grade_one_hat_05': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_05.svg'),
    'grade_one_hat_06': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_06.svg'),
    'grade_one_hat_07': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_07.svg'),
    'grade_one_hat_08': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_08.svg'),
    'grade_one_hat_09': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_09.svg'),
    'grade_one_hat_10': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_10.svg'),
    'grade_one_hat_11': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_11.svg'),
    'grade_one_hat_12': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_12.svg'),
    'grade_one_hat_13': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_13.svg'),
    'grade_one_hat_14': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_14.svg'),
    'grade_one_hat_15': require('@/assets/image/accessories/Accessories_G1/cloth_g1_hat_15.svg'),

    'grade_one_pants_01': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_01.svg'),
    'grade_one_pants_02': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_02.svg'),
    'grade_one_pants_03': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_03.svg'),
    'grade_one_pants_04': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_04.svg'),
    'grade_one_pants_05': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_05.svg'),
    'grade_one_pants_06': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_06.svg'),
    'grade_one_pants_07': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_07.svg'),
    'grade_one_pants_08': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_08.svg'),
    'grade_one_pants_09': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_09.svg'),
    'grade_one_pants_10': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_10.svg'),

    'grade_one_shirt_01': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_01.svg'),
    'grade_one_shirt_02': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_02.svg'),
    'grade_one_shirt_03': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_03.svg'),
    'grade_one_shirt_04': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_04.svg'),
    'grade_one_shirt_05': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_05.svg'),
    'grade_one_shirt_06': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_06.svg'),
    'grade_one_shirt_07': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_07.svg'),
    'grade_one_shirt_08': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_08.svg'),
    'grade_one_shirt_09': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_09.svg'),
    'grade_one_shirt_10': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_10.svg'),
    'grade_one_shirt_11': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_11.svg'),
    'grade_one_shirt_12': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_12.svg'),
    'grade_one_shirt_13': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_13.svg'),
    'grade_one_shirt_14': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_14.svg'),
    'grade_one_shirt_15': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_15.svg'),

    'grade_one_shoe_01': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shoe_01.svg'),
    'grade_one_shoe_02': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shoe_02.svg'),
    'grade_one_shoe_03': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shoe_03.svg'),
    'grade_one_shoe_04': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shoe_04.svg'),
    'grade_one_shoe_05': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shoe_05.svg'),
    'grade_one_shoe_06': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shoe_06.svg'),
    'grade_one_shoe_07': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shoe_07.svg'),
    'grade_one_shoe_08': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shoe_08.svg'),

    'grade_one_sleeve_01': require('@/assets/image/accessories/Accessories_G1/sleeves/cloth_g1_sleeve_01.svg'),
    'grade_one_sleeve_02': require('@/assets/image/accessories/Accessories_G1/sleeves/cloth_g1_sleeve_02.svg'),
    'grade_one_sleeve_04': require('@/assets/image/accessories/Accessories_G1/sleeves/cloth_g1_sleeve_04.svg'),
    'grade_one_sleeve_06': require('@/assets/image/accessories/Accessories_G1/sleeves/cloth_g1_sleeve_06.svg'),
    'grade_one_sleeve_07': require('@/assets/image/accessories/Accessories_G1/sleeves/cloth_g1_sleeve_07.svg'),
    'grade_one_sleeve_08': require('@/assets/image/accessories/Accessories_G1/sleeves/cloth_g1_sleeve_08.svg'),
    'grade_one_sleeve_09': require('@/assets/image/accessories/Accessories_G1/sleeves/cloth_g1_sleeve_09.svg'),
    'grade_one_sleeve_14': require('@/assets/image/accessories/Accessories_G1/sleeves/cloth_g1_sleeve_14.svg'),
    'grade_one_sleeve_15': require('@/assets/image/accessories/Accessories_G1/sleeves/cloth_g1_sleeve_15.svg'),

    //grade two
    'grade_two_item_01': require('@/assets/image/accessories/Accessories_G2/accessory_item_01.svg'),
    'grade_two_item_02': require('@/assets/image/accessories/Accessories_G2/accessory_item_02.svg'),
    'grade_two_item_03': require('@/assets/image/accessories/Accessories_G2/accessory_item_03.svg'),
    'grade_two_item_04': require('@/assets/image/accessories/Accessories_G2/accessory_item_04.svg'),
    'grade_two_item_05': require('@/assets/image/accessories/Accessories_G2/accessory_item_05.svg'),
    'grade_two_item_06': require('@/assets/image/accessories/Accessories_G2/accessory_item_06.svg'),
    'grade_two_item_07': require('@/assets/image/accessories/Accessories_G2/accessory_item_07.svg'),
    'grade_two_item_08': require('@/assets/image/accessories/Accessories_G2/accessory_item_08.svg'),
    'grade_two_item_09': require('@/assets/image/accessories/Accessories_G2/accessory_item_09.svg'),
    'grade_two_item_10': require('@/assets/image/accessories/Accessories_G2/accessory_item_10.svg'),
    'grade_two_item_11': require('@/assets/image/accessories/Accessories_G2/accessory_item_11.svg'),
    'grade_two_item_12': require('@/assets/image/accessories/Accessories_G2/accessory_item_12.svg'),
    'grade_two_item_13': require('@/assets/image/accessories/Accessories_G2/accessory_item_13.svg'),
    'grade_two_item_14': require('@/assets/image/accessories/Accessories_G2/accessory_item_14.svg'),
    'grade_two_item_15': require('@/assets/image/accessories/Accessories_G2/accessory_item_15.svg'),
    'grade_two_item_16': require('@/assets/image/accessories/Accessories_G2/accessory_item_16.svg'),
    'grade_two_item_17': require('@/assets/image/accessories/Accessories_G2/cloth_g2_item_17.svg'),
    'grade_two_item_18': require('@/assets/image/accessories/Accessories_G2/cloth_g2_item_18.svg'),

    'grade_two_hat_01': require('@/assets/image/accessories/Accessories_G2/accessory_hat_01.svg'),
    'grade_two_hat_02': require('@/assets/image/accessories/Accessories_G2/accessory_hat_02.svg'),
    'grade_two_hat_03': require('@/assets/image/accessories/Accessories_G2/accessory_hat_03.svg'),
    'grade_two_hat_04': require('@/assets/image/accessories/Accessories_G2/accessory_hat_04.svg'),
    'grade_two_hat_05': require('@/assets/image/accessories/Accessories_G2/accessory_hat_05.svg'),
    'grade_two_hat_06': require('@/assets/image/accessories/Accessories_G2/accessory_hat_06.svg'),
    'grade_two_hat_07': require('@/assets/image/accessories/Accessories_G2/accessory_hat_07.svg'),
    'grade_two_hat_08': require('@/assets/image/accessories/Accessories_G2/accessory_hat_08.svg'),
    'grade_two_hat_09': require('@/assets/image/accessories/Accessories_G2/accessory_hat_09.svg'),
    'grade_two_hat_10': require('@/assets/image/accessories/Accessories_G2/accessory_hat_10.svg'),
    'grade_two_hat_11': require('@/assets/image/accessories/Accessories_G2/accessory_hat_11.svg'),
    'grade_two_hat_12': require('@/assets/image/accessories/Accessories_G2/accessory_hat_12.svg'),
    'grade_two_hat_13': require('@/assets/image/accessories/Accessories_G2/accessory_hat_13.svg'),
    'grade_two_hat_14': require('@/assets/image/accessories/Accessories_G2/cloth_g2_hat_14.svg'),
    'grade_two_hat_15': require('@/assets/image/accessories/Accessories_G2/cloth_g2_hat_15.svg'),

    'grade_two_pants_01': require('@/assets/image/accessories/Accessories_G2/accessory_pants_01.svg'),
    'grade_two_pants_02': require('@/assets/image/accessories/Accessories_G2/accessory_pants_02.svg'),
    'grade_two_pants_03': require('@/assets/image/accessories/Accessories_G2/accessory_pants_03.svg'),
    'grade_two_pants_04': require('@/assets/image/accessories/Accessories_G2/accessory_pants_04.svg'),
    'grade_two_pants_05': require('@/assets/image/accessories/Accessories_G2/accessory_pants_05.svg'),
    'grade_two_pants_06': require('@/assets/image/accessories/Accessories_G2/accessory_pants_06.svg'),
    'grade_two_pants_07': require('@/assets/image/accessories/Accessories_G2/accessory_pants_07.svg'),
    'grade_two_pants_08': require('@/assets/image/accessories/Accessories_G2/accessory_pants_08.svg'),
    'grade_two_pants_09': require('@/assets/image/accessories/Accessories_G2/accessory_pants_09.svg'),
    'grade_two_pants_10': require('@/assets/image/accessories/Accessories_G1/cloth_g1_pants_10.svg'),

    'grade_two_shirt_01': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_01.svg'),
    'grade_two_shirt_02': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_02.svg'),
    'grade_two_shirt_03': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_03.svg'),
    'grade_two_shirt_04': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_04.svg'),
    'grade_two_shirt_05': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_05.svg'),
    'grade_two_shirt_06': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_06.svg'),
    'grade_two_shirt_07': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_07.svg'),
    'grade_two_shirt_08': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_08.svg'),
    'grade_two_shirt_09': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_09.svg'),
    'grade_two_shirt_10': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_10.svg'),
    'grade_two_shirt_11': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_11.svg'),
    'grade_two_shirt_12': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_12.svg'),
    'grade_two_shirt_13': require('@/assets/image/accessories/Accessories_G2/accessory_shirt_13.svg'),
    'grade_two_shirt_14': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_14.svg'),
    'grade_two_shirt_15': require('@/assets/image/accessories/Accessories_G1/cloth_g1_shirt_15.svg'),

    'grade_two_shoe_01': require('@/assets/image/accessories/Accessories_G2/accessory_shoe_01.svg'),
    'grade_two_shoe_02': require('@/assets/image/accessories/Accessories_G2/accessory_shoe_02.svg'),
    'grade_two_shoe_03': require('@/assets/image/accessories/Accessories_G2/accessory_shoe_03.svg'),
    'grade_two_shoe_04': require('@/assets/image/accessories/Accessories_G2/accessory_shoe_04.svg'),
    'grade_two_shoe_05': require('@/assets/image/accessories/Accessories_G2/accessory_shoe_05.svg'),
    'grade_two_shoe_06': require('@/assets/image/accessories/Accessories_G2/accessory_shoe_06.svg'),
    'grade_two_shoe_07': require('@/assets/image/accessories/Accessories_G2/accessory_shoe_07.svg'),
    'grade_two_shoe_08': require('@/assets/image/accessories/Accessories_G2/accessory_shoe_08.svg'),

    'grade_two_sleeve_01': require('@/assets/image/accessories/Accessories_G2/sleeves/accessory_shirt_01.svg'),
    'grade_two_sleeve_02': require('@/assets/image/accessories/Accessories_G2/sleeves/accessory_shirt_02.svg'),
    'grade_two_sleeve_04': require('@/assets/image/accessories/Accessories_G2/sleeves/accessory_shirt_04.svg'),
    'grade_two_sleeve_06': require('@/assets/image/accessories/Accessories_G2/sleeves/accessory_shirt_06.svg'),
    'grade_two_sleeve_07': require('@/assets/image/accessories/Accessories_G2/sleeves/accessory_shirt_07.svg'),
    'grade_two_sleeve_08': require('@/assets/image/accessories/Accessories_G2/sleeves/accessory_shirt_08.svg'),
    'grade_two_sleeve_09': require('@/assets/image/accessories/Accessories_G2/sleeves/accessory_shirt_09.svg'),
    'grade_two_sleeve_14': require('@/assets/image/accessories/Accessories_G2/sleeves/cloth_g2_sleeve_14.svg'),
    'grade_two_sleeve_15': require('@/assets/image/accessories/Accessories_G2/sleeves/cloth_g2_sleeve_15.svg'),

    //grade three
    'grade_three_item_01': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-01.svg'),
    'grade_three_item_02': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-02.svg'),
    'grade_three_item_03': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-03.svg'),
    'grade_three_item_04': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-04.svg'),
    'grade_three_item_05': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-05.svg'),
    'grade_three_item_06': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-06.svg'),
    'grade_three_item_07': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-07.svg'),
    'grade_three_item_08': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-08.svg'),
    'grade_three_item_09': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-09.svg'),
    'grade_three_item_10': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-10.svg'),
    'grade_three_item_11': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-11.svg'),
    'grade_three_item_12': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-12.svg'),
    'grade_three_item_13': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-13.svg'),
    'grade_three_item_14': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-14.svg'),
    'grade_three_item_15': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-15.svg'),
    'grade_three_item_16': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item-16.svg'),
    'grade_three_item_17': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item_17.svg'),
    'grade_three_item_18': require('@/assets/image/accessories/Accessories_G3/cloth_g3_item_18.svg'),

    'grade_three_hat_01': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-01.svg'),
    'grade_three_hat_02': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-02.svg'),
    'grade_three_hat_03': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-03.svg'),
    'grade_three_hat_04': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-04.svg'),
    'grade_three_hat_05': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-05.svg'),
    'grade_three_hat_06': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-06.svg'),
    'grade_three_hat_07': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-07.svg'),
    'grade_three_hat_08': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-08.svg'),
    'grade_three_hat_09': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-09.svg'),
    'grade_three_hat_10': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-10.svg'),
    'grade_three_hat_11': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-11.svg'),
    'grade_three_hat_12': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-12.svg'),
    'grade_three_hat_13': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat-13.svg'),
    'grade_three_hat_14': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat_14.svg'),
    'grade_three_hat_15': require('@/assets/image/accessories/Accessories_G3/cloth_g3_hat_15.svg'),

    'grade_three_pants_01': require('@/assets/image/accessories/Accessories_G3/cloth_g3_pants-01.svg'),
    'grade_three_pants_02': require('@/assets/image/accessories/Accessories_G3/cloth_g3_pants-02.svg'),
    'grade_three_pants_03': require('@/assets/image/accessories/Accessories_G3/cloth_g3_pants-03.svg'),
    'grade_three_pants_04': require('@/assets/image/accessories/Accessories_G3/cloth_g3_pants-04.svg'),
    'grade_three_pants_05': require('@/assets/image/accessories/Accessories_G3/cloth_g3_pants-05.svg'),
    'grade_three_pants_06': require('@/assets/image/accessories/Accessories_G3/cloth_g3_pants-06.svg'),
    'grade_three_pants_07': require('@/assets/image/accessories/Accessories_G3/cloth_g3_pants-07.svg'),
    'grade_three_pants_08': require('@/assets/image/accessories/Accessories_G3/cloth_g3_pants-08.svg'),
    'grade_three_pants_09': require('@/assets/image/accessories/Accessories_G3/cloth_g3_pants-09.svg'),
    'grade_three_pants_10': require('@/assets/image/accessories/Accessories_G3/cloth_g3_pants_10.svg'),


    'grade_three_shirt_01': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-01.svg'),
    'grade_three_shirt_02': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-02.svg'),
    'grade_three_shirt_03': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-03.svg'),
    'grade_three_shirt_04': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-04.svg'),
    'grade_three_shirt_05': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-05.svg'),
    'grade_three_shirt_06': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-06.svg'),
    'grade_three_shirt_07': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-07.svg'),
    'grade_three_shirt_08': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-08.svg'),
    'grade_three_shirt_09': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-09.svg'),
    'grade_three_shirt_10': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-10.svg'),
    'grade_three_shirt_11': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-11.svg'),
    'grade_three_shirt_12': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-12.svg'),
    'grade_three_shirt_13': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt-13.svg'),
    'grade_three_shirt_14': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt_14.svg'),
    'grade_three_shirt_15': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shirt_15.svg'),

    'grade_three_shoe_01': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shoe-01.svg'),
    'grade_three_shoe_02': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shoe-02.svg'),
    'grade_three_shoe_03': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shoe-03.svg'),
    'grade_three_shoe_04': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shoe-04.svg'),
    'grade_three_shoe_05': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shoe-05.svg'),
    'grade_three_shoe_06': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shoe-06.svg'),
    'grade_three_shoe_07': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shoe-07.svg'),
    'grade_three_shoe_08': require('@/assets/image/accessories/Accessories_G3/cloth_g3_shoe-08.svg'),

    'grade_three_sleeve_01': require('@/assets/image/accessories/Accessories_G3/sleeves/cloth_g3_sleeve-01.svg'),
    'grade_three_sleeve_02': require('@/assets/image/accessories/Accessories_G3/sleeves/cloth_g3_sleeve-02.svg'),
    'grade_three_sleeve_04': require('@/assets/image/accessories/Accessories_G3/sleeves/cloth_g3_sleeve-04.svg'),
    'grade_three_sleeve_06': require('@/assets/image/accessories/Accessories_G3/sleeves/cloth_g3_sleeve-06.svg'),
    'grade_three_sleeve_07': require('@/assets/image/accessories/Accessories_G3/sleeves/cloth_g3_sleeve-07.svg'),
    'grade_three_sleeve_08': require('@/assets/image/accessories/Accessories_G3/sleeves/cloth_g3_sleeve-08.svg'),
    'grade_three_sleeve_09': require('@/assets/image/accessories/Accessories_G3/sleeves/cloth_g3_sleeve-09.svg'),
    'grade_three_sleeve_14': require('@/assets/image/accessories/Accessories_G3/sleeves/cloth_g3_sleeve_14.svg'),
    'grade_three_sleeve_15': require('@/assets/image/accessories/Accessories_G3/sleeves/cloth_g3_sleeve_15.svg'),
    
};

const accessoryDatas = [
    {
        id: 'item_01',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_01'],
            'grade-two': accessoryRepository['grade_two_item_01'],
            'grade-three': accessoryRepository['grade_three_item_01']
        }
    },
    {
        id: 'item_02',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_02'],
            'grade-two': accessoryRepository['grade_two_item_02'],
            'grade-three': accessoryRepository['grade_three_item_02']
        }
    },
    {
        id: 'item_03',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_03'],
            'grade-two': accessoryRepository['grade_two_item_03'],
            'grade-three': accessoryRepository['grade_three_item_03']
        }
    },
    {
        id: 'item_04',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_04'],
            'grade-two': accessoryRepository['grade_two_item_04'],
            'grade-three': accessoryRepository['grade_three_item_04']
        }
    },
    {
        id: 'item_05',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_05'],
            'grade-two': accessoryRepository['grade_two_item_05'],
            'grade-three': accessoryRepository['grade_three_item_05']
        }
    },
    {
        id: 'item_06',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_06'],
            'grade-two': accessoryRepository['grade_two_item_06'],
            'grade-three': accessoryRepository['grade_three_item_06']
        }
    },
    {
        id: 'item_07',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_07'],
            'grade-two': accessoryRepository['grade_two_item_07'],
            'grade-three': accessoryRepository['grade_three_item_07']
        }
    },
    {
        id: 'item_08',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_08'],
            'grade-two': accessoryRepository['grade_two_item_08'],
            'grade-three': accessoryRepository['grade_three_item_08']
        }
    },
    {
        id: 'item_09',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_09'],
            'grade-two': accessoryRepository['grade_two_item_09'],
            'grade-three': accessoryRepository['grade_three_item_09']
        }
    },
    {
        id: 'item_10',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_10'],
            'grade-two': accessoryRepository['grade_two_item_10'],
            'grade-three': accessoryRepository['grade_three_item_10']
        }
    },
    {
        id: 'item_11',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_11'],
            'grade-two': accessoryRepository['grade_two_item_11'],
            'grade-three': accessoryRepository['grade_three_item_11']
        }
    },
    {
        id: 'item_12',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_12'],
            'grade-two': accessoryRepository['grade_two_item_12'],
            'grade-three': accessoryRepository['grade_three_item_12']
        }
    }, {
        id: 'item_13',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_13'],
            'grade-two': accessoryRepository['grade_two_item_13'],
            'grade-three': accessoryRepository['grade_three_item_13']
        }
    }, {
        id: 'item_14',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_14'],
            'grade-two': accessoryRepository['grade_two_item_14'],
            'grade-three': accessoryRepository['grade_three_item_14']
        }
    }, {
        id: 'item_15',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_15'],
            'grade-two': accessoryRepository['grade_two_item_15'],
            'grade-three': accessoryRepository['grade_three_item_15']
        }
    }, {
        id: 'item_16',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_16'],
            'grade-two': accessoryRepository['grade_two_item_16'],
            'grade-three': accessoryRepository['grade_three_item_16']
        }
    }, {
        id: 'item_17',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_17'],
            'grade-two': accessoryRepository['grade_two_item_17'],
            'grade-three': accessoryRepository['grade_three_item_17']
        }
    },
    {
        id: 'item_18',
        name: 'Pom Pom',
        category: AID.HAND,
        bodyType: 'arm_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_item_18'],
            'grade-two': accessoryRepository['grade_two_item_18'],
            'grade-three': accessoryRepository['grade_three_item_18']
        }
    },


    //HATS
    {
        id: 'hat_01',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_01'],
            'grade-two': accessoryRepository['grade_two_hat_01'],
            'grade-three': accessoryRepository['grade_three_hat_01']
        }
    },
    {
        id: 'hat_02',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_02'],
            'grade-two': accessoryRepository['grade_two_hat_02'],
            'grade-three': accessoryRepository['grade_three_hat_02']
        }
    },
    {
        id: 'hat_03',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_03'],
            'grade-two': accessoryRepository['grade_two_hat_03'],
            'grade-three': accessoryRepository['grade_three_hat_03']
        }
    },
    {
        id: 'hat_04',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_04'],
            'grade-two': accessoryRepository['grade_two_hat_04'],
            'grade-three': accessoryRepository['grade_three_hat_04']
        }
    },
    {
        id: 'hat_05',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_05'],
            'grade-two': accessoryRepository['grade_two_hat_05'],
            'grade-three': accessoryRepository['grade_three_hat_05']
        }
    },
    {
        id: 'hat_06',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_06'],
            'grade-two': accessoryRepository['grade_two_hat_06'],
            'grade-three': accessoryRepository['grade_three_hat_06']
        }
    },
    {
        id: 'hat_07',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_07'],
            'grade-two': accessoryRepository['grade_two_hat_07'],
            'grade-three': accessoryRepository['grade_three_hat_07']
        }
    },
    {
        id: 'hat_08',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_08'],
            'grade-two': accessoryRepository['grade_two_hat_08'],
            'grade-three': accessoryRepository['grade_three_hat_08']
        }
    },
    {
        id: 'hat_09',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_09'],
            'grade-two': accessoryRepository['grade_two_hat_09'],
            'grade-three': accessoryRepository['grade_three_hat_09']
        }
    },
    {
        id: 'hat_10',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_10'],
            'grade-two': accessoryRepository['grade_two_hat_10'],
            'grade-three': accessoryRepository['grade_three_hat_10']
        }
    },
    {
        id: 'hat_11',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_11'],
            'grade-two': accessoryRepository['grade_two_hat_11'],
            'grade-three': accessoryRepository['grade_three_hat_11']
        }
    },
    {
        id: 'hat_12',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_12'],
            'grade-two': accessoryRepository['grade_two_hat_12'],
            'grade-three': accessoryRepository['grade_three_hat_12']
        }
    },
    {
        id: 'hat_13',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_13'],
            'grade-two': accessoryRepository['grade_two_hat_13'],
            'grade-three': accessoryRepository['grade_three_hat_13']
        }
    },
    {
        id: 'hat_14',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_14'],
            'grade-two': accessoryRepository['grade_two_hat_14'],
            'grade-three': accessoryRepository['grade_three_hat_14']
        }
    },
    {
        id: 'hat_15',
        name: 'Fietshelm',
        category: AID.HAT,
        bodyType: 'head',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_hat_15'],
            'grade-two': accessoryRepository['grade_two_hat_15'],
            'grade-three': accessoryRepository['grade_three_hat_15']
        }
    },

    // PANTS
    {
        id: 'pants_01',
        name: 'Fietsbroek',
        category: AID.PANTS,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_pants_01'],
            'grade-two': accessoryRepository['grade_two_pants_01'],
            'grade-three': accessoryRepository['grade_three_pants_01']
        }
    },
    {
        id: 'pants_02',
        name: 'Fietsbroek',
        category: AID.PANTS,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_pants_02'],
            'grade-two': accessoryRepository['grade_two_pants_02'],
            'grade-three': accessoryRepository['grade_three_pants_02']
        }
    },
    {
        id: 'pants_03',
        name: 'Fietsbroek',
        category: AID.PANTS,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_pants_03'],
            'grade-two': accessoryRepository['grade_two_pants_03'],
            'grade-three': accessoryRepository['grade_three_pants_03']
        }
    },
    {
        id: 'pants_04',
        name: 'Fietsbroek',
        category: AID.PANTS,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_pants_04'],
            'grade-two': accessoryRepository['grade_two_pants_04'],
            'grade-three': accessoryRepository['grade_three_pants_04']
        }
    },
    {
        id: 'pants_05',
        name: 'Fietsbroek',
        category: AID.PANTS,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_pants_05'],
            'grade-two': accessoryRepository['grade_two_pants_05'],
            'grade-three': accessoryRepository['grade_three_pants_05']
        }
    },
    {
        id: 'pants_06',
        name: 'Fietsbroek',
        category: AID.PANTS,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_pants_06'],
            'grade-two': accessoryRepository['grade_two_pants_06'],
            'grade-three': accessoryRepository['grade_three_pants_06']
        }
    },
    {
        id: 'pants_07',
        name: 'Fietsbroek',
        category: AID.PANTS,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_pants_07'],
            'grade-two': accessoryRepository['grade_two_pants_07'],
            'grade-three': accessoryRepository['grade_three_pants_07']
        }
    },
    {
        id: 'pants_08',
        name: 'Fietsbroek',
        category: AID.PANTS,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_pants_08'],
            'grade-two': accessoryRepository['grade_two_pants_08'],
            'grade-three': accessoryRepository['grade_three_pants_08']
        }
    },
    {
        id: 'pants_09',
        name: 'Fietsbroek',
        category: AID.PANTS,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_pants_09'],
            'grade-two': accessoryRepository['grade_two_pants_09'],
            'grade-three': accessoryRepository['grade_three_pants_09']
        }
    },
    {
        id: 'pants_10',
        name: 'Fietsbroek',
        category: AID.PANTS,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_pants_10'],
            'grade-two': accessoryRepository['grade_two_pants_10'],
            'grade-three': accessoryRepository['grade_three_pants_10']
        }
    },

    // SHIRT
    {
        id: 'shirt_01',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_01'],
            'grade-two': accessoryRepository['grade_two_shirt_01'],
            'grade-three': accessoryRepository['grade_three_shirt_01']
        }
    },
    {
        id: 'shirt_02',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_02'],
            'grade-two': accessoryRepository['grade_two_shirt_02'],
            'grade-three': accessoryRepository['grade_three_shirt_02']
        }
    },
    {
        id: 'shirt_03',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_03'],
            'grade-two': accessoryRepository['grade_two_shirt_03'],
            'grade-three': accessoryRepository['grade_three_shirt_03']
        }
    },
    {
        id: 'shirt_04',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_04'],
            'grade-two': accessoryRepository['grade_two_shirt_04'],
            'grade-three': accessoryRepository['grade_three_shirt_04']
        }
    },
    {
        id: 'shirt_05',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_05'],
            'grade-two': accessoryRepository['grade_two_shirt_05'],
            'grade-three': accessoryRepository['grade_three_shirt_05']
        }
    },
    {
        id: 'shirt_06',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_06'],
            'grade-two': accessoryRepository['grade_two_shirt_06'],
            'grade-three': accessoryRepository['grade_three_shirt_06']
        }
    },
    {
        id: 'shirt_07',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_07'],
            'grade-two': accessoryRepository['grade_two_shirt_07'],
            'grade-three': accessoryRepository['grade_three_shirt_07']
        }
    },
    {
        id: 'shirt_08',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_08'],
            'grade-two': accessoryRepository['grade_two_shirt_08'],
            'grade-three': accessoryRepository['grade_three_shirt_08']
        }
    },
    {
        id: 'shirt_09',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_09'],
            'grade-two': accessoryRepository['grade_two_shirt_09'],
            'grade-three': accessoryRepository['grade_three_shirt_09']
        }
    },
    {
        id: 'shirt_10',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_10'],
            'grade-two': accessoryRepository['grade_two_shirt_10'],
            'grade-three': accessoryRepository['grade_three_shirt_10']
        }
    },
    {
        id: 'shirt_11',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_11'],
            'grade-two': accessoryRepository['grade_two_shirt_11'],
            'grade-three': accessoryRepository['grade_three_shirt_11']
        }
    },
    {
        id: 'shirt_12',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_12'],
            'grade-two': accessoryRepository['grade_two_shirt_12'],
            'grade-three': accessoryRepository['grade_three_shirt_12']
        }
    },
    {
        id: 'shirt_13',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_13'],
            'grade-two': accessoryRepository['grade_two_shirt_13'],
            'grade-three': accessoryRepository['grade_three_shirt_13']
        }
    },
    {
        id: 'shirt_14',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_14'],
            'grade-two': accessoryRepository['grade_two_shirt_14'],
            'grade-three': accessoryRepository['grade_three_shirt_14']
        }
    },
    {
        id: 'shirt_15',
        name: 'Fiets-shirt',
        category: AID.SHIRT,
        bodyType: 'body',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shirt_15'],
            'grade-two': accessoryRepository['grade_two_shirt_15'],
            'grade-three': accessoryRepository['grade_three_shirt_15']
        }
    },


    // SHOE
    {
        id: 'shoe_01',
        name: 'Ballerina',
        category: AID.SHOE_LEFT,
        bodyType: 'leg_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shoe_01'],
            'grade-two': accessoryRepository['grade_two_shoe_01'],
            'grade-three': accessoryRepository['grade_three_shoe_01']
        }
    },
    {
        id: 'shoe_02',
        name: 'Ballerina',
        category: AID.SHOE_LEFT,
        bodyType: 'leg_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shoe_02'],
            'grade-two': accessoryRepository['grade_two_shoe_02'],
            'grade-three': accessoryRepository['grade_three_shoe_02']
        }
    }, {
        id: 'shoe_03',
        name: 'Ballerina',
        category: AID.SHOE_LEFT,
        bodyType: 'leg_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shoe_03'],
            'grade-two': accessoryRepository['grade_two_shoe_03'],
            'grade-three': accessoryRepository['grade_three_shoe_03']
        }
    }, {
        id: 'shoe_04',
        name: 'Ballerina',
        category: AID.SHOE_LEFT,
        bodyType: 'leg_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shoe_04'],
            'grade-two': accessoryRepository['grade_two_shoe_04'],
            'grade-three': accessoryRepository['grade_three_shoe_04']
        }
    }, {
        id: 'shoe_05',
        name: 'Ballerina',
        category: AID.SHOE_LEFT,
        bodyType: 'leg_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shoe_05'],
            'grade-two': accessoryRepository['grade_two_shoe_05'],
            'grade-three': accessoryRepository['grade_three_shoe_05']
        }
    }, {
        id: 'shoe_06',
        name: 'Ballerina',
        category: AID.SHOE_LEFT,
        bodyType: 'leg_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shoe_06'],
            'grade-two': accessoryRepository['grade_two_shoe_06'],
            'grade-three': accessoryRepository['grade_three_shoe_06']
        }
    },
    {
        id: 'shoe_07',
        name: 'Ballerina',
        category: AID.SHOE_LEFT,
        bodyType: 'leg_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shoe_07'],
            'grade-two': accessoryRepository['grade_two_shoe_07'],
            'grade-three': accessoryRepository['grade_three_shoe_07']
        }
    },
    {
        id: 'shoe_08',
        name: 'Ballerina',
        category: AID.SHOE_LEFT,
        bodyType: 'leg_left',
        customisable: true,
        svgs: {
            'grade-one': accessoryRepository['grade_one_shoe_08'],
            'grade-two': accessoryRepository['grade_two_shoe_08'],
            'grade-three': accessoryRepository['grade_three_shoe_08']
        }
    },

    {
        id: 'sleeve_01',
        name: 'sleeve_01',
        category: AID.SLEEVE_LEFT,
        bodyType: 'arm_left',
        customisable: false,
        svgs: {
            'grade-one': accessoryRepository['grade_one_sleeve_01'],
            'grade-two': accessoryRepository['grade_two_sleeve_01'],
            'grade-three': accessoryRepository['grade_three_sleeve_01']
        }
    },
    {
        id: 'sleeve_02',
        name: 'sleeve_02',
        category: AID.SLEEVE_LEFT,
        bodyType: 'arm_left',
        customisable: false,
        svgs: {
            'grade-one': accessoryRepository['grade_one_sleeve_02'],
            'grade-two': accessoryRepository['grade_two_sleeve_02'],
            'grade-three': accessoryRepository['grade_three_sleeve_02']
        }
    },
    {
        id: 'sleeve_04',
        name: 'sleeve_04',
        category: AID.SLEEVE_LEFT,
        bodyType: 'arm_left',
        customisable: false,
        svgs: {
            'grade-one': accessoryRepository['grade_one_sleeve_04'],
            'grade-two': accessoryRepository['grade_two_sleeve_04'],
            'grade-three': accessoryRepository['grade_three_sleeve_04']
        }
    },
    {
        id: 'sleeve_06',
        name: 'sleeve_06',
        category: AID.SLEEVE_LEFT,
        bodyType: 'arm_left',
        customisable: false,
        svgs: {
            'grade-one': accessoryRepository['grade_one_sleeve_06'],
            'grade-two': accessoryRepository['grade_two_sleeve_06'],
            'grade-three': accessoryRepository['grade_three_sleeve_06']
        }
    },
    {
        id: 'sleeve_07',
        name: 'sleeve_07',
        category: AID.SLEEVE_LEFT,
        bodyType: 'arm_left',
        customisable: false,
        svgs: {
            'grade-one': accessoryRepository['grade_one_sleeve_07'],
            'grade-two': accessoryRepository['grade_two_sleeve_07'],
            'grade-three': accessoryRepository['grade_three_sleeve_07']
        }
    },
    {
        id: 'sleeve_08',
        name: 'sleeve_08',
        category: AID.SLEEVE_LEFT,
        bodyType: 'arm_left',
        customisable: false,
        svgs: {
            'grade-one': accessoryRepository['grade_one_sleeve_08'],
            'grade-two': accessoryRepository['grade_two_sleeve_08'],
            'grade-three': accessoryRepository['grade_three_sleeve_08']
        }
    },
    {
        id: 'sleeve_09',
        name: 'sleeve_09',
        category: AID.SLEEVE_LEFT,
        bodyType: 'arm_left',
        customisable: false,
        svgs: {
            'grade-one': accessoryRepository['grade_one_sleeve_09'],
            'grade-two': accessoryRepository['grade_two_sleeve_09'],
            'grade-three': accessoryRepository['grade_three_sleeve_09']
        }
    },
    {
        id: 'sleeve_14',
        name: 'sleeve_14',
        category: AID.SLEEVE_LEFT,
        bodyType: 'arm_left',
        customisable: false,
        svgs: {
            'grade-one': accessoryRepository['grade_one_sleeve_14'],
            'grade-two': accessoryRepository['grade_two_sleeve_14'],
            'grade-three': accessoryRepository['grade_three_sleeve_14']
        }
    },
    {
        id: 'sleeve_15',
        name: 'sleeve_15',
        category: AID.SLEEVE_LEFT,
        bodyType: 'arm_left',
        customisable: false,
        svgs: {
            'grade-one': accessoryRepository['grade_one_sleeve_15'],
            'grade-two': accessoryRepository['grade_two_sleeve_15'],
            'grade-three': accessoryRepository['grade_three_sleeve_15']
        }
    },

];

const shirtSleeveIds = {
    'shirt_01': 'sleeve_01',
    'shirt_02': 'sleeve_02',
    'shirt_03': '',
    'shirt_04': 'sleeve_04',
    'shirt_05': '',
    'shirt_06': 'sleeve_06',
    'shirt_07': 'sleeve_07',
    'shirt_08': 'sleeve_08',
    'shirt_09': 'sleeve_09',
    'shirt_14': 'sleeve_14',
    'shirt_15': 'sleeve_15',

}

const parser = new DOMParser();

export default class AccessoryLibrary
{

    static getAccessoryFromFile(id, grade)
    {
        return new Promise((resolve) =>
        {
            //console.log("getting acc location for id " + id + " and grade " + grade)
            let assetLocation = this.getAccessoryLocationForGrade(grade, id);
            fetch(assetLocation)
                .then(r => r.text())
                .then(text =>
                {
                    let doc = parser.parseFromString(text, "image/svg+xml");
                    let svgEL = doc.getElementsByTagNameNS("http://www.w3.org/2000/svg", "svg").item(0);
                    let resultObject = {
                        id: id,
                        svg: svgEL
                    }
                    resolve(resultObject);
                })
                .catch(console.error.bind(console));
        });
    }

    static getAccessoryLocationForGrade(schoolYear, id)
    {
        //logger.info("getting accessory location for id " + id + " and grade " + grade)
        let data = this.findDataForId(id);

        if (data == null)
        {
            return null;
        }
        
        let location = null;

        let grade = utils.getGradeForSchoolYear(schoolYear);

        switch (grade)
        {
            case 1:
                location = data.svgs['grade-one'];
                break;
            case 2:
                location = data.svgs['grade-two'];
                break;
            case 3:
                location = data.svgs['grade-three'];
                break;
        }
        return location;
    }

    static getAllCustomisableAccessories(grade)
    {
        //console.log("getting all customisable accessories for grade " + grade);
        return new Promise(function(resolve, reject)
        {
            let promises = [];

            accessoryDatas.forEach(data =>
            {

                let promise = AccessoryLibrary.getAccessoryFromFile(data.id, grade);
                promises.push(promise);
            });

            Promise.all(promises).then((values) =>
                {
                    let combined = AccessoryLibrary.combineDataAndSvg(values, true);
                    //console.log(combined);
                    resolve(combined);
                })
                .catch(function(error)
                {
                    console.log(error);
                    reject(error);
                });
        });
    }

    static combineDataAndSvg(svgs, onlyCustomisables)
    {
        let dataAndSvgs = {};
        svgs.forEach(svgPart =>
        {
            let data = AccessoryLibrary.findDataForId(svgPart.id);
            //console.log(data);
            if ((onlyCustomisables && data.customisable === true) || !onlyCustomisables)
            {
                let combined = {
                    id: data.id,
                    name: data.name,
                    bodyType: data.bodyType,
                    category: data.category,
                    svg: svgPart.svg,
                }

                //create category if it doesn't exist yet
                if (!(data.category in dataAndSvgs))
                {
                    dataAndSvgs[data.category] = {
                        id: data.category,
                        name: AccessoryNames[data.category],
                        parts: []
                    };
                }

                dataAndSvgs[data.category].parts.push(combined);
            }


        });

        return dataAndSvgs;
    }

    static findDataForId(id)
    {
        let result = null;
        accessoryDatas.forEach(data =>
        {
            if (data.id === id)
            {
                result = data;
            }
        });
        return result;
    }

    static getSleeveForShirtId(id)
    {
        if (shirtSleeveIds[id] !== '')
        {
            return this.findDataForId(shirtSleeveIds[id]);
        }
        else
        {
            return { name: '', id: '' };
        }
    }
}

